import type { HealthPlanAction } from '../../../../../shared/dpRequests';
import type { ChoiceOption } from '../ChoiceCards';

export const HEALTH_ACTION_OPTIONS: ReadonlyArray<ChoiceOption<HealthPlanAction>> = [
    { value: 'include', label: 'Inclusão no plano', description: 'Incluir você ou dependentes no plano de saúde.' },
    { value: 'change', label: 'Mudança de plano', description: 'Trocar de operadora.' },
    { value: 'leave', label: 'Sair do plano', description: 'Sair do plano ou retirar dependentes.' },
];

export const LEAVE_SCOPE_OPTIONS: ReadonlyArray<ChoiceOption<'holder' | 'dependents'>> = [
    { value: 'holder', label: 'Eu saio do plano', description: 'Os dependentes saem junto.' },
    { value: 'dependents', label: 'Só dependentes', description: 'Escolha quem sai.' },
];

export const NEEDS_PLAN_MESSAGE = 'Mudança e saída só estão disponíveis para quem já tem plano de saúde cadastrado.';
export const OPEN_REQUEST_MESSAGE = 'Você já tem um pedido de plano de saúde em andamento. Acompanhe em Meus pedidos.';
